module.exports = __webpack_public_path__ + "img/dgzjcs.bf229be6.png";